"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SAPPartnerPayablePayload = exports.SAPPartnerPayableTransport = exports.SAPPartnerPayableActionTypeLabels = exports.SAPPartnerPayableActionType = exports.SAPPartnerPayableActionTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
const payable_transport_1 = require("./payable-transport");
exports.SAPPartnerPayableActionTypes = ['APPROVE', 'REJECT', 'RESET'];
exports.SAPPartnerPayableActionType = typebox_1.Type.Union(exports.SAPPartnerPayableActionTypes.map((action) => typebox_1.Type.Literal(action)));
/**
 * Object mapping actions to their corresponding labels.
 */
exports.SAPPartnerPayableActionTypeLabels = {
    APPROVE: 'Approve',
    REJECT: 'Reject',
    RESET: 'Reset the payable',
};
exports.SAPPartnerPayableTransport = typebox_1.Type.Object({
    action: exports.SAPPartnerPayableActionType,
    payable: payable_transport_1.PayableTransport,
});
const SAPPartnerPayableApprovePayload = typebox_1.Type.Object({
    action: typebox_1.Type.Literal('APPROVE'),
    invoiceDetails: typebox_1.Type.Optional(typebox_1.Type.Object({
        issueDate: typebox_1.Type.String({ format: 'date-time' }),
        term: typebox_1.Type.Integer({ minimum: 0 }),
    })),
});
const SAPPartnerPayableRejectPayload = typebox_1.Type.Object({
    action: typebox_1.Type.Literal('REJECT'),
    noteForHauler: typebox_1.Type.String(),
    noteForVendorRelations: typebox_1.Type.String(),
});
const SAPPartnerPayableResetPayload = typebox_1.Type.Object({
    action: typebox_1.Type.Literal('RESET'),
    note: typebox_1.Type.String(),
});
exports.SAPPartnerPayablePayload = typebox_1.Type.Union([
    SAPPartnerPayableApprovePayload,
    SAPPartnerPayableRejectPayload,
    SAPPartnerPayableResetPayload,
]);
//# sourceMappingURL=sap-partner-payable.js.map